import type React from "react";
import CreateNameForm from "../common/CreateNameForm";

interface CreateVendorFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { name: string }) => Promise<void>;
  error: string | null;
  initialData?: { name: string };
  isEditing?: boolean;
}

const CreateVendorForm: React.FC<CreateVendorFormProps> = (props) => {
  return (
    <CreateNameForm
      {...props}
      entityName="Vendor"
      labelTranslationKey="Vendor Name"
      placeholder="Vendor name"
      addTextTranslationKey="Add Vendor"
      editTextTranslationKey="Edit Vendor"
    />
  );
};

export default CreateVendorForm;
